const getAll = '/email-templates'

const EmailTemplateService = {
  getAll
}

export default EmailTemplateService
